import { render, staticRenderFns } from "./WallElementSelect.vue?vue&type=template&id=ffe391ac&"
import script from "./WallElementSelect.vue?vue&type=script&lang=js&"
export * from "./WallElementSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports